module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_72022683_XL-small-5749a29bcc98e3b349282f8322996091.jpg";